export const IndividualConversationStyle = {
    conversationStyle: {
        border: '1px solid #E1E1E1',
        borderRadius: '10px',
        padding: '15px',
        margin: '15px 0',
        width: '80%',
        color: '#333',
        fontFamily: 'Arial, sans-serif',
    },

    nameStyle: {
        fontWeight: 'bold',
        color: '#EA4C89',
        marginBottom: '5px',
    },

    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#fefcfe',
        padding: '20px',
    },

    headerStyle: {
        fontSize: '30px',
        fontWeight: 'bold',
        color: '#49B0E2',
        marginBottom: '20px',
    },

    headerImageStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },

    iconStyle: {
        width: '40px',
        height: '40px',
        margin: '0 10px',
        cursor: 'pointer',
    },

    homeLinkStyle: {
        fontSize: '20px',
        color: '#333',
        cursor: 'pointer',
    },

    contentWrapperStyle: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        transition: "margin-right 0.3s ease",
        paddingBottom: "40px",
    },

    logoStyle:{
        width: "78px",
        height: "78px",
        marginLeft: "20px",
    }
};